import React from 'react';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

type DeliveryV1Props = {
    productCard: ShowableProductCard
}

const DeliveryV1 = observer((props: DeliveryV1Props) => {

    let wrapClasses: string[] = [];
    wrapClasses = [
        'info-block-v1',
        'box-v1',
        'box-v1_filling-type-contained',
        'box-v1_filling-color-type-gray',
        'info-block-v1_text-color-type-text'
    ];

    let deliveryString: string | null = 
        props.productCard.currentDeliveryObject?.value;

    if (deliveryString === null) {
        wrapClasses.push('_hide');
    }

    return (
        <div className={wrapClasses.join(' ')}>
            <div className="info-block-v1__icon">    
                <svg className="icon-v1" width="39" height="26">
                    <use xlinkHref="/build/sprite.svg#delivery-icon"></use>
                </svg>
            </div>
            <div 
                className="info-block-v1__content"
                dangerouslySetInnerHTML={{ __html: deliveryString as string }}
                >
            </div>
        </div>
    );

})

export default DeliveryV1;